import { MediaContentType } from '../../../../api/MediaContentTypeApi';
import { CategoricalContent } from '../context/CategoricalContentTypeContext';

export function countUsedContentByCategory({
  categoricalContent,
  materialCategory,
  contentTypeIds,
}: {
  categoricalContent: CategoricalContent[];
  materialCategory?: string;
  contentTypeIds?: string;
}) {
  return (
    categoricalContent
      ?.find(({ name }) => name === materialCategory)
      ?.contentTypes?.reduce((total, { used, id }) => {
        if (!contentTypeIds || contentTypeIds.includes(id)) {
          return total + used;
        }
        return total;
      }, 0) ?? 0
  );
}

export function countContentType(contentTypes: MediaContentType[], contentTypeId: string): number {
  return contentTypes.reduce((total, ct) => (ct.id === contentTypeId ? total + ct.used : total), 0);
}
